var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare63B = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M49 56H7.5A2.5 2.5 0 0 1 5 53.5V46h42.237a2.5 2.5 0 0 1 2.488 2.749L49 56Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M56 11v42.5a2.5 2.5 0 0 1-2.5 2.5H46V13.5a2.5 2.5 0 0 1 2.5-2.5H56Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M37 4h16.5A2.5 2.5 0 0 1 56 6.5V14H38.763a2.5 2.5 0 0 1-2.488-2.749L37 4ZM4 37v16.5A2.5 2.5 0 0 0 6.5 56H14V38.763a2.5 2.5 0 0 0-2.749-2.488L4 37Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M4 36v17.5A2.5 2.5 0 0 0 6.5 56h47a2.5 2.5 0 0 0 2.5-2.5v-47A2.5 2.5 0 0 0 53.5 4H36"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20 22.5a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5v-15Z"
})));
SvgSquare63B.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare63B);
export default ForwardRef;